import { MapaPeligroApi } from '@/domain/entities/Api'
import { Commit } from '@/store/types'
import { getEnvironments } from '@/environments'
import { checkWebp } from '@/components/helpers/checkWebp'
import { client as fetch } from './ClientService'

export interface MapaPeligroInterface {
  getMapaPeligro(): Promise<Commit<MapaPeligroApi[]>>
}

export default class MapaPeligroService implements MapaPeligroInterface {
  env = getEnvironments()
  apiUrl: string = this.env.url.API ? this.env.url.API : window.location.origin
  hash: string = this.env.settings.PELIGRO.hash || ''
  webp: string = '&webp=0'

  constructor (apiUrl?: string) {
    this.apiUrl = apiUrl || this.apiUrl
  }

  async getMapaPeligro (): Promise<Commit<MapaPeligroApi[]>> {
    try {
      const { isWebpSupported } = await checkWebp('lossy')
      this.webp = isWebpSupported && this.env.settings.PELIGRO.useWebp ? '&webp=1' : '&webp=0'
      const response: MapaPeligroApi[] = await fetch(`${this.apiUrl}/api/mapas_peligro?${this.hash}${this.webp}`)
      return { type: 'MAPA_PELIGRO_FETCHED', payload: response }
    } catch (e) {
      return { type: 'MAPA_PELIGRO_ERROR', payload: e }
    }
  }
}
